import { DsAlertModal } from './DsAlertModal';
import { DsConfirmModalProps } from './types';

export function DsConfirmModal({ ...props }: DsConfirmModalProps) {
  return <DsAlertModal type={props.type ? props.type : 'danger'} disableEscapeKeyDown {...props} />;
}
